export enum EventType {
  uploadComplete = 'UploadComplete',
}
